import React,{ useEffect, useState } from "react";
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'
import CompleteRegistration from "./components/CompleteRegistration";
import Home from "./components/Home";
import Menu from "./components/Menu";
import BranchDetails from "./components/BranchDetails";
import Branches from "./components/Branches";
import Test from "./Pages/Test";
import {  ToastContainer } from 'react-toastify'
import { auth } from "./firebase"
import {useDispatch} from 'react-redux'
import firebase from "firebase";
import { useHistory} from 'react-router-dom'
import Checkout from "./components/Checkout";
import Myprofile from "./components/Myprofile";
import MenusCategories from "./components/MenusCategories";
import GoogleAd from 'react-google-ad'
import GoogleAds from "./GoogleAds";


function App() {

  const dispatch = useDispatch()
 const history = useHistory()
 const [loggedUid, setLoggedUid] = useState('')

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if(user){
        const idTokenResult = await user.getIdTokenResult()
        dispatch({
          type: 'LOGGED_IN_USER',
          payload: {
            email: user.email,
            token: idTokenResult.token,
            
          }
        })
        setLoggedUid(`${user?.uid}`)
      }
    })
    return () => unsubscribe()
  }, [])

  const logout = () =>{
    firebase.auth().signOut()
     dispatch({
       type: 'LOGOUT',
       payload: null
     })
     history.push("/")
  }

  
  
  return (
    <div>
      <ToastContainer />
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/test" component={Test} />
          <Route exact path="/branches" component={Branches} />
          <Route exact path="/branchdetails/:branchId" component={BranchDetails} />
          <Route exact path="/complete/registration" component={CompleteRegistration} />
          <Route exact path="/my-profile/:uid" component={Myprofile} />
          <Route exact path="/menu" component={Menu} />
          <Route exact path="/category/:id" component={MenusCategories} />
          <Route exact path="/check-out">
              <Checkout user={loggedUid} />
            </Route>
        </Switch>
      </Router>

{/* <div className="ad-class">
     <GoogleAds slot="4493379164" /></div> */}

{/* <GoogleAd client='ca-pub-9058298844141347' slot="4493379164" format="fluid" /> */}

    </div>
  );
}

export default App;
